import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// declare var gtag: Function; // declare GA global

@Injectable({
  providedIn: 'root'
})
export class CookieConsentService {
  private consentKey = 'cookie_consent';
  private consentStatus$ = new BehaviorSubject<string | null>(this.getConsent());

  constructor() {
    // On init, make sure GA respects stored consent
    const savedConsent = this.getConsent();
    if (savedConsent === 'accepted') {
      this.grantConsent();
    } else {
      this.denyConsent();
    }
  }

  getConsent(): string | null {
    return localStorage.getItem(this.consentKey);
  }

  hasAccepted(): boolean {
    return this.getConsent() === 'accepted';
  }

  setConsent(value: 'accepted' | 'rejected'): void {
    localStorage.setItem(this.consentKey, value);
    this.consentStatus$.next(value);

    if (value === 'accepted') {
      this.grantConsent();
    } else {
      this.denyConsent();
    }
  }

  watchConsent() {
    return this.consentStatus$.asObservable();
  }

  private grantConsent(): void {
    // gtag('consent', 'update', {
    //   ad_storage: 'granted',
    //   analytics_storage: 'granted'
    // });
    // // optional: trigger another page_view
    // gtag('config', 'G-L5PZN0E0SE', { anonymize_ip: false });
    // gtag('event', 'page_view');
  }

  private denyConsent(): void {
    // gtag('consent', 'update', {
    //   ad_storage: 'denied',
    //   analytics_storage: 'denied'
    // });
  }
}
